import { render } from "./MaterialSelect.vue?vue&type=template&id=77a36dbc&ts=true"
import script from "./MaterialSelect.vue?vue&type=script&lang=ts"
export * from "./MaterialSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__